module.exports = __webpack_public_path__ + "static/slidertogo-6a5ae1d6867ee8ef7be9beffe1ea16c6.png";